import { useState, useEffect } from "react";

import { fetchAgentPriceMarkupInfo } from "../../../services/agentServices";
import Type1FullFlightDetailsCard from "./FullFlightDetailsCards/Type1FullFlightDetailsCard";
import Type4FullFlightDetailsCard from "./FullFlightDetailsCards/Type4FullFlightDetailsCard";

const SelectedTicketInfo = (props) => {

    const {
        rawData,
        data_provider,
        bookingEngine,
        hasNewMessageFromParent,
        currentParentMessge,
        unselectFlightOffer,
        begin_checkout,
        flight,
    } = props;

    const [ PriceMarkupValue, setPriceMarkupValue ] = useState({
        type: "",
        value: 0,
    });
    const [ canShowPrice, setCanShowPrice ] = useState({
        profit_type: "",
        with_price_bound_profit: false,
        show: false,
    });

    useEffect(()=>{
        (async()=>{
            let _pm_obj = {
                type: "",
                value: 0,
            }
            let _can_show_obj = {
                profit_type: "",
                with_price_bound_profit: false,
                show: false,
            }
            setCanShowPrice(_can_show_obj);
            setPriceMarkupValue(_pm_obj);
            if(
                hasNewMessageFromParent &&
                currentParentMessge?.from_welldugo_oc &&
                currentParentMessge?.type==="engine-parameters"
            ){
                if(currentParentMessge?.postBody?.apply_price_bound_profile){
                    _pm_obj.type = currentParentMessge?.postBody?.current_price_bound_profit_type;
                    _pm_obj.value = currentParentMessge?.postBody?.current_price_bound_profit_value;
                    _can_show_obj.with_price_bound_profit = true;
                    _can_show_obj.show = true;
                }else{
                    _can_show_obj.with_price_bound_profit = false;
                    _can_show_obj.show = true;
                }
                //currentParentMessge?.postBody?.current_price_bound_supplier: "duffel",
            }else if(localStorage.getItem("engine_parameters")){
                const engine_parameters = JSON.parse(localStorage.getItem("engine_parameters"));
                if(engine_parameters?.postBody?.apply_price_bound_profile){
                    _pm_obj.type = engine_parameters?.postBody?.current_price_bound_profit_type;
                    _pm_obj.value = engine_parameters?.postBody?.current_price_bound_profit_value;
                    _can_show_obj.with_price_bound_profit = true;
                    _can_show_obj.show = true;
                    console.log(engine_parameters);
                }else{
                    _can_show_obj.with_price_bound_profit = false;
                    _can_show_obj.show = true;
                }
            }else {
                if(localStorage.getItem("agent")){
                    const agent_id = localStorage.getItem("agent");
                    if(agent_id || agent_id!=="undefined"){
                        let _pm_res = await fetchAgentPriceMarkupInfo(agent_id);
                        _pm_obj.type = _pm_res?.type;
                        _pm_obj.value = _pm_res?.value;
                        _can_show_obj.with_price_bound_profit = true;
                        _can_show_obj.show = true;
                    }
                }
            }

            // Update State Here
            setPriceMarkupValue({
                type: _pm_obj?.type,
                value: parseFloat(_pm_obj?.value),
            });
            setCanShowPrice({
                ...canShowPrice,
                with_price_bound_profit: _can_show_obj?.with_price_bound_profit,
                show: _can_show_obj?.show,
            });
        })();
    }, [currentParentMessge]);

    const infoCardType = parseInt((bookingEngine.searchResultFullFlightDetailsCard || 1));

    return <div>
        {
            infoCardType === 1 &&
            <Type1FullFlightDetailsCard 
                PriceMarkupValue={PriceMarkupValue}
                canShowPrice={canShowPrice}
                rawData={rawData}
                data_provider={data_provider}
                bookingEngine={bookingEngine}
                hasNewMessageFromParent={hasNewMessageFromParent}
                currentParentMessge={currentParentMessge}
                unselectFlightOffer={unselectFlightOffer}
                begin_checkout={begin_checkout}
                flight={flight}
            />
        }
        {
            infoCardType === 4 &&
            <Type4FullFlightDetailsCard 
                PriceMarkupValue={PriceMarkupValue}
                canShowPrice={canShowPrice}
                rawData={rawData}
                data_provider={data_provider}
                bookingEngine={bookingEngine}
                hasNewMessageFromParent={hasNewMessageFromParent}
                currentParentMessge={currentParentMessge}
                unselectFlightOffer={unselectFlightOffer}
                begin_checkout={begin_checkout}
                flight={flight}
            />
        }
    </div>
    
}

export default SelectedTicketInfo;